// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc704ede","455":"2042aa91","977":"dbc3dda0"}[chunkId] + ".chunk.js";
};